import axios from 'axios';
import authHeader from './auth-header';

const config = require("../config/config.js");

const API_URL = config.API_URL + 'auth/';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'signin', {
        username: user.username,
        password: user.password,
        otp: user.otp
      })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    localStorage.removeItem('user');
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      email: user.email,
      password: user.password,
      limit:user.limit
    },{ headers: authHeader() });
  }
  generate2fa() {
    return axios.get(API_URL + 'generate2fa', { headers: authHeader() });
  }
  validate(user) {
    return axios.post(API_URL + 'validate', user, { headers: authHeader() });
  }
}

export default new AuthService();
